import { Loader } from "./Loader";
import { ImageResource } from "./ImageResource";

export class Effect {

    public images: ImageResource[];
    public diffuse: ImageResource;

    public loadBlob(dataView: DataView, loader: Loader) {

        this.images = [];

        let offset = 0;

        let imageCount = dataView.getInt32(offset, true);
        offset += 4;

        for (let i = 0; i < imageCount; i++) {
            let imageReference = dataView.getInt32(offset, true);
            offset += 4;

            this.images.push(loader.getBlob<ImageResource>(imageReference));
        }

        let diffuseReference = dataView.getInt32(offset, true);
        offset += 4;
        this.diffuse = loader.getBlob<ImageResource>(diffuseReference);
    }
}
